<template>
  <v-text-field
      :error-messages="error"
      :label="translation(translationList.building, 'Bloc')"
      v-model="building"
      :rules="buildingValidationRules"
      name="building"
      variant="outlined"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    addressIndex: Number as () => number | null,
  },
  setup(props, { emit }) {
    const { modelValue, addressIndex } = toRefs(props);
    const building = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      building.value = newValue;
    });

    watch(building, (newValue) => {
      const isValid = validateBuilding(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `building-${addressIndex.value}` : 'building', isValid });
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const buildingValidationRules = [
      (v: string) => /^[A-Za-z0-9\s]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateBuilding(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = buildingValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return buildingValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateBuilding(building.value);
      emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `building-${addressIndex.value}` : 'building', isValid });

      // Listen for validate events
      window.addEventListener('validate-address', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === (Number.isInteger(addressIndex.value) ? `building-${addressIndex.value}` : 'building')) {
        const isValid = validateBuilding(building.value, true);
        if (isValid) {
          emit('validation-address-status', { field: Number.isInteger(addressIndex.value) ? `building-${addressIndex.value}` : 'building', isValid });
        }
      }
    };

    return {
      building,
      buildingValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>